import React from 'react'
import { Dispatch } from 'redux'
import { PackType } from '../../types/pack'
import { Modals } from '../../types/modal'
import { modalClose, modalOpen } from '../../actions/modal'
import { deletePack } from '../../actions/pack'
import Modal from '../Modal'
import { DangerButton } from '../DangerButton'
import { P } from '../StyledText'

export interface IPackDeleteComponent {
  pack: PackType
  activeModal?: string
  dispatch: Dispatch
}

export const PackDeleteComponent = ({
  pack: { id, title, canDelete },
  activeModal,
  dispatch,
}: IPackDeleteComponent) => (
  <>
    <DangerButton
      fullWidth
      id="delete-pack-dialog"
      variant="text"
      onClick={() => {
        dispatch(modalOpen(Modals.deleteConfirmModal))
      }}
      disabled={!canDelete}
    >
      Delete
    </DangerButton>
    <Modal
      id="delete-pack-modal-dialog"
      open={activeModal === Modals.deleteConfirmModal}
      handleClose={() => {
        dispatch(modalClose())
      }}
      action={() => {
        if (id) {
          dispatch(deletePack(id))
        }
        dispatch(modalClose())
      }}
      title="Pack deletion"
      actionLabel="Delete"
    >
      <P>
        This pack will be deleted - please note that this action is not
        reversible and cannot be undone.
      </P>
      <br />
      <P>
        Are you sure you want to delete <strong>{title || 'Untitled'} </strong>
        pack?
      </P>
    </Modal>
  </>
)
